import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="line-item"
export default class extends Controller {
  static targets = [ "checked" ]
  static values = { url: String }

  connect() {
    this.isSubmitting = false
  }

  submit(event) {
    event.preventDefault()

    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true

    this.checkedTarget.value = 1

    this.element.closest("form").submit()
  }

  // mettre à jour la dispo et le total
  refresh(event) {
    const url = new URL(this.urlValue)
    
    const value = event.detail.quantity  || event.currentTarget.value

    if (!value) { return }

    const quantity = parseInt(value)
    if (quantity == 'NaN' || quantity < 1) { return; }

    url.searchParams.set("purchase_order_item[quantity]",  quantity)

    if (this.controller) { 
      this.controller.abort()
    }

    this.controller = new AbortController();
    const signal = this.controller.signal;

    this.dispatch("refresh-start", { })

    fetch(url, { signal })
      .then((resp)=>resp.text())
      .then((html)=>this.element.outerHTML = html)
      .then(()=>this.dispatch('refresh-stop'))
      .catch((e)=>{})
  }
}
